import { Button, Center, Group, Modal, Switch, Text, Tooltip } from '@mantine/core';
import { useDisclosure } from '@mantine/hooks';
import { IconEdit, IconEye } from '@tabler/icons-react';
import { useMutation } from '@tanstack/react-query';
import React, { useState } from 'react'
import { Link } from 'react-router-dom';
import { updateAgencyStatus } from '../../../api/agency';
import { successNotification } from '../../../utility/notification';
import classes from '../Agency.module.css';

function ActionCell({ row }) {
    const [isSwitchOn, setIsSwitchOn] = useState(row.active);
    const [opened, { open, close }] = useDisclosure(false);

    const handleSwitchChange = () => {

        close();
        setIsSwitchOn(!isSwitchOn)

    };

    const { isPending, mutate } = useMutation({
        mutationFn: updateAgencyStatus,
        onSuccess: (res) => {
            successNotification({
                message: res?.message
            });
            handleSwitchChange()
        }
    })
    return (
        <>
            <Group justify="center" p="md" > <Switch type="checkbox"
                checked={isSwitchOn}
                onChange={open} /><Link to={`/agencies/${row.id}/edit`}><div
                    className={classes.icon_button}
                ><Tooltip label="Edit">
                        <IconEdit style={{ color: 'white', fontSize: '20px', alignItems: 'center' }} />
                    </Tooltip></div></Link><Link to={`/agencies/${row.code}/show`}><div
                        className={classes.icon_button}
                    ><Tooltip label="Show Users List">
                            <IconEye style={{ color: 'white', fontSize: '20px', alignItems: 'center' }} />
                        </Tooltip></div></Link></Group>
            <Modal opened={opened} onClose={close}
                centered
                title="Confirm">

                <Text>Are you sure you want to {!isSwitchOn ? 'Activate' : 'Inactive'} the agency ?</Text>


                <Center mt={"md"}>
                    <Button onClick={() => mutate({
                        id: row?.id,
                        status: !isSwitchOn
                    })}
                        loading={isPending}
                    >Confirm</Button>
                </Center>

            </Modal>
        </>
    )
}

export default ActionCell
